import { IChapter, IDraftChapter, IDraftChapterCreate } from "../models/wall";
import { axiosInstance } from "../utils";
import { ApiResponse } from "./wall";

export const getDraftChaptersByStoryId = async (storyId: string): Promise<ApiResponse<IDraftChapter>> => {
  const response = await axiosInstance.get<ApiResponse<IDraftChapter>>(`/draft-chapters/`, {
    params: {story: storyId}
  });

  return response.data;
}
export const getDraftChaptersById = async (id: string): Promise<IDraftChapter> => {
  const response = await axiosInstance.get<IDraftChapter>(`/draft-chapters/${id}/`);

  return response.data;
}
export const createEmptyDraftChapter = async (draft: IDraftChapterCreate): Promise<IDraftChapter> => {
  const response = await axiosInstance.post<IDraftChapter>(`/draft-chapters/`, draft);

  return response.data;
}
export const updateDraftChapterApi = async (id: string, draft: Partial<IDraftChapter>): Promise<IDraftChapter> => {
  const response = await axiosInstance.patch<IDraftChapter>(`/draft-chapters/${id}/`, draft);

  return response.data;
}
export const restoreDraftChapter = async (id: string): Promise<IChapter> => {
  const response = await axiosInstance.patch<IChapter>(`/draft-chapters/${id}/restore/`);

  return response.data;
}
export const publishDraftChapter = async (id: string): Promise<IChapter> => {
  const response = await axiosInstance.post<IChapter>(`/draft-chapters/${id}/publish/`);

  return response.data;
}
export const deleteDraftChapter = async (id: string): Promise<void> => {
  const response = await axiosInstance.delete(`/draft-chapters/${id}/`);
}
